<template>
  <div>
    <div class="mt-15 container card_container">
      <anagrafica :codiceImpegnativa="presaInCarico.nre" :priorita="presaInCarico.classePriorita" :assistito="assistito"></anagrafica>

      <div class="separator border-4 my-3"></div>
      <div>
        <b-alert show variant="warning">
          <h4 class="alert-heading">Attenzione!</h4>
          <p>
          {{infoPrenotazione}}
          </p>
        </b-alert>
      </div>
      <h3 class="mb-5 titolo"><i class="fas fa-clipboard-list"></i> riepilogo</h3>
      <datatable-riepilogo v-if="presaInCarico" :erogabili="prestazioneErogabiliFiltrate" :presaInCarico="presaInCarico.prestazioni"></datatable-riepilogo>
      <b-container class="bv-example-row">
        <b-row>
          <b-col>
            <a>
              <b-button variant="outline-secondary" class="w-100" @click="onAnnulla"
                ><i class="fas fa-trash"></i>
                Annulla
              </b-button>
            </a>
          </b-col>
          <b-col></b-col>
          <b-col></b-col>
          <b-col></b-col>
          <b-col></b-col>
          <b-col>
            <a>
              <b-button class="w-100 btn-outline" @click="primaDisponibilita"
                ><i class="fas fa-chevron-right"></i>
                Avanti
              </b-button>
            </a>
          </b-col>
        </b-row>
      </b-container>
      <modal-disponibilita v-if="jsonData.nonErogabili" ref="modalDisponibilita" :nonErogabili="jsonData.nonErogabili"></modal-disponibilita>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots" :height="120" :width="120"></loading>
  </div>
</template>
<script>
import anagrafica from "../anagrafica/anagrafica.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import datatableRiepilogo from "../datatable/datatableRiepilogo.vue";
import modalDisponibilita from "../modal/modalDisponibilita.vue";
import UtilityMixin from "../../utilities/utilityMixin.js";
import EngiService from "@/services/engiService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";

export default {
  mixins: [UtilityMixin],
  props: {
    assistito: Object,
    presaInCarico: Object,
    prestazioneErogabiliFiltrate: Array,
  },
  components: {
    anagrafica,
    datatableRiepilogo,
    modalDisponibilita,
    Loading,
  },
  data() {
    return {
        infoPrenotazione:"Al momento della prenotazione verrà indicata la prima data utile. " +
            "Qualora il cittadino rifiuti la prima proposta esce dall’ambito di garanzia del rispetto dei tempi di attesa previsto dalla classe di priorità assegnata.\n" +
            " Se il cittadino vuole procedere con una prenotazione presso una struttura sanitaria specifica, i tempi di attesa potrebbero " +
            "essere più lunghi di quelli previsti.",
       showModal: false,
       isLoading: false,
        jsonData: {
          sendData: [],
          nonErogabili: [],
          erogabili: [],
        },
        responsePresaInCarico: {},
        token: null,
        tokenLogin: null,
        pathControlloPrestazioni: "/api/v2.0/appecupt/aslengi/controlloPrestazioni",
        pathResourceAnnulla: "/api/v2.0/appecupt/aslengi/annullaprenotazionesospesa",
        pathPrimaDisponibilita: "/api/v2.0/appecupt/aslengi/ricercaDisponibilita",
    };
  },
  mounted: function () {
    let me = this;
    me.token = sessionStorage.getItem("tokenWSO2");
    me.tokenLogin = sessionStorage.getItem("loginData");
      let msg = getVocabolario("infoPrenotazione")
      if(msg)
          this.infoPrenotazione = msg;

      me.prestazioneErogabiliFiltrate = me.presaInCarico.prestazioni.reduce((oldItem, newItem) => {
      const x = oldItem.find(item => item.desPrestazione === newItem.desPrestazione);
      console.log("x", x);
      if (!x) {
        newItem.quantita = 1;
        return oldItem.concat([newItem]);
      } else {
        for(let i = 0; i < oldItem.length; i++) {
          if(oldItem[i].desPrestazione === newItem.desPrestazione) {
            oldItem[i].quantita = oldItem[i].quantita + 1;
          }
        }
        return oldItem;
      }
    }, []);
    console.log(me.prestazioneErogabiliFiltrate)
  },
  methods: {
    async primaDisponibilita() {
      let me = this;
      me.isLoading = true;
      me.presaInCarico.prestazioni.forEach((item) => {
        me.jsonData.sendData.push({
          idPrestazioneAnagrafica: item.idPrestazioneAnagrafica,
          idPrestazione: item.idPrestazione,
          reparto: item.reparto,
        });
      });
      try {
        const responsePrimaDisponibilita = await EngiService.ricercaPrimaDisponibilitaNre(me.jsonData.sendData);
        if (responsePrimaDisponibilita.data.stato === 200) {
          me.isLoading = false;
          if (responsePrimaDisponibilita.data.data.length === 0) {

              let msg = getVocabolario("prescrizioneNonPrenotabile")
              if(!msg)
                  msg = "Siamo spiacenti. Per la prenotazione delle prestazioni prescritte nella Sua ricetta è necessario rivolgersi agli sportelli Cup Aziendali o al Call Center."
            this.$bvModal
              .msgBoxOk(msg, {
                title: "Attenzione",
                size: "sm",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {
                me.onAnnulla();
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            me.$emit("getPrimaDisponibilita", responsePrimaDisponibilita.data);
            me.$emit("setStep", 2);
          }
        }
        else if(responsePrimaDisponibilita.data.stato === 500){
          me.isLoading = false;
          this.$bvModal
            .msgBoxOk(responsePrimaDisponibilita.data.messaggio, {
              title: "Attenzione",
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {
              me.onAnnulla();
            })
            .catch((err) => {
              console.log(err);
            });
        }
        else if (responsePrimaDisponibilita.data.stato === 510) {
          me.isLoading = false;
          me.$emit("getPrimaDisponibilita", responsePrimaDisponibilita.data);
          me.$emit("setStep", 2);
        }
        else {
          me.isLoading = false;
            let msg = getVocabolario("prescrizioneNonPrenotabile")
            if(!msg)
                msg = "Siamo spiacenti. Per la prenotazione delle prestazioni prescritte nella Sua ricetta è necessario rivolgersi agli sportelli Cup Aziendali o al Call Center."

            this.$bvModal
              .msgBoxOk(msg, {
                title: "Attenzione",
                size: "sm",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(async () => {
                  me.isLoading = true;
                  try {
                      await EngiService.annullaPrenotazioneSospesa()
                          .then(() => {
                              me.isLoading = false;
                              me.$emit("setStep", 0);
                          })
                          .catch((error) => {
                              me.isLoading = false;
                              console.log(error);
                              this.$bvModal
                                  .msgBoxOk(error.response, {
                                      title: "Errore",
                                      size: "sm",
                                      okVariant: "outline-danger",
                                      headerClass: "vv-msg-header-danger",
                                      footerClass: "p-2 border-top-0",
                                      centered: true,
                                  })
                                  .then(() => {})
                                  .catch(() => {});
                          });
                  } catch (e) {
                      me.isLoading = false;
                      me.$bvModal
                          .msgBoxOk(e, {
                              title: "Errore",
                              size: "md",
                              okVariant: "outline-danger",
                              headerClass: "vv-msg-header-danger",
                              footerClass: "p-2 border-top-0",
                              centered: true,
                          })
                          .then(() => {})
                          .catch(() => {});
                  }
              })
              .catch((err) => {
                console.log(err);
              });
        }
      } catch (e) {
        me.isLoading = false;
        me.$bvModal
          .msgBoxOk(e, {
            title: "Errore",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then(() => {})
          .catch(() => {});
      }
    },
    onAnnulla() {
      let me = this;

        let msg = getVocabolario("messaggioAnnullaProceduraPrenotazione")
        if(!msg)
            msg = "Sei sicuro di voler annullare la procedura di Prenotazione dell'impegnativa  "
      me.$bvModal
        .msgBoxConfirm(msg + me.presaInCarico.nre + " ?", {
          title: "Conferma Annullamento",
          footerClass: "p-2",
          centered: true,
          cancelTitle: "Chiudi",
          okTitle: "Conferma",
        })
        .then(async (response) => {
          if (response) {
            me.isLoading = true;
            try {
              await EngiService.annullaPrenotazioneSospesa()
                .then(() => {
                  me.isLoading = false;
                  me.$emit("setStep", 0);
                })
                .catch((error) => {
                  me.isLoading = false;
                  console.log(error);
                  this.$bvModal
                    .msgBoxOk(error.response, {
                      title: "Errore",
                      size: "sm",
                      okVariant: "outline-danger",
                      headerClass: "vv-msg-header-danger",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                    })
                    .then(() => {})
                    .catch(() => {});
                });
            } catch (e) {
              me.isLoading = false;
              me.$bvModal
                .msgBoxOk(e, {
                  title: "Errore",
                  size: "md",
                  okVariant: "outline-danger",
                  headerClass: "vv-msg-header-danger",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then(() => {})
                .catch(() => {});
            }
          }
        });
    },
  },
};
</script>
